import {
  SettingsActiveItem,
  SettingsMenuItemProps,
} from 'types/account-settings';
import SettingsMenu from '../molecules/SettingsMenu';
import { useTranslation } from 'react-i18next';

export default function AccountSettingsMenu({
  activeItem,
}: SettingsActiveItem) {
  const { t } = useTranslation();

  const menuItems: SettingsMenuItemProps[] = [
    {
      title: t(
        'settings.sidebar.organization.partnerProgram',
        'Partner Program'
      ),
      route: '/settings/account/installer/partner-program',
      iconName: 'trophy',
    },
  ];

  return SettingsMenu({
    header: t('settings.sidebar.installer.title', 'Installer'),
    menuItems: menuItems,
    activeItem,
  });
}
